import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {getIntersectedCPSelection, getTaskCustomFieldsMap, getTaskNameFilter, getTaskStatusFilter, isShowOnlyManageableTasks} from '../common/selectors'
import {getShownColumnsWithOrder, getTasksSorting} from '../tasksTable/selectors'
import {convertTaskListAndSaveAsCsv} from './utils'
import {afterTaskListExportRequestFailed} from '../syncCallbacks'
import {isTWSEnabled} from '../../features/selectors'
import {makeLoadTasksRequest} from '../tasksTable/connector'

const setExportInProgress = createAction(ActionTypes.CSV_EXPORT_IN_PROGRESS_SET)

export const exportTaskListCsv = () => (dispatch, getState) => {
    dispatch(setExportInProgress(true))
    const state = getState()
    const columnsWithOrder = getShownColumnsWithOrder(state)
    const taskCustomFields = getTaskCustomFieldsMap(state)
    makeLoadTasksRequest({
        intersectedCPSelection: getIntersectedCPSelection(state),
        taskStatusFilter: getTaskStatusFilter(state),
        taskNameFilter: getTaskNameFilter(state),
        showOnlyManageableTasks: isShowOnlyManageableTasks(state),
        taskSorting: getTasksSorting(state),
        offset: 0,
    }).then((data) => {
        convertTaskListAndSaveAsCsv(data, columnsWithOrder, taskCustomFields, isTWSEnabled(state))
        dispatch(setExportInProgress(false))
    })
      .catch((err) => {
          dispatch(setExportInProgress(false))
          afterTaskListExportRequestFailed(err)
      })
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/actions.js